<template>

<div class="col-xl-3 col-lg-4 p-0">
    <div class="rate-sidebar shadow-lg project-timeline-holder">
        <div class="responsive-project-title d-flex justify-content-between align-items-center">
            <h6>Оцени предложението</h6>
            <span id="close-timeline" class="icon icon-x"></span>
        </div>
        <div class="rate-title pl-4 pr-4 pt-4">
            <p class="sub-title">оцени това</p>
            <h2 class="title text-left mb-2">Предложение</h2>
        </div>

        <div v-if='isReady' class="rate-items-holder pl-4 pr-4">
            <ol v-for="(c,n,i) in criterias" class="list-group rate-items">
                <li class="list-group-item rate-item border-top-0 border-left-0 
                    border-right-0 pl-2 pr-2 pt-2 pb-2">
                    <div class="d-flex w-100 align-items-start">
                        <div class="rate-num mr-2">{{ i + 1 }}.</div>
                        <div class="question mt-2">
                            {{ c }}
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="rate-slider w-100">
                            <input type="range"
                                    :disabled='hasReview'
                                    @change='setScore'
                                   v-model='review[n]' 
                                   class="custom-range pl-0 pr-0" min="1" max="5" step="0.5" 
                                   :id="'cr-' + (i+1)">
                            <ol class="rate-scale d-flex justify-content-between">
                                <li><span class="icon icon-thumbs-down"></span></li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li><span class="icon icon-thumbs-up"></span></li>
                            </ol>
                        </div>

                        <div class="rate-result flex-shrink-1 ml-2">{{ review[n] }}</div>
                    </div>
                </li>
            </ol>
        </div>

        <div class="sidebar-bottom pr-4 pl-4 shadow">

            <div v-if='!hasReview' class="final-rating-holder d-flex align-items-center pt-3 pb-0">
                <span class="rate-result final-rating flex-shrink-1 mt-1">{{ review.score }}</span>
                <button @click='leaveReview' class="btn btn-primary btn-block ml-3" :disabled='isLoading'>
                    <span class="icon icon-check"></span>
                    Постави тази оценка
                </button>                      
            </div>

            <div v-if='hasReview' class="final-rating-holder d-flex align-items-center pt-3 pb-0">
                <span class="rate-result final-rating flex-shrink-1 mt-1">{{ review.score }}</span>
                 - Поставената от вас оценка              
            </div>

            <div v-if='hasWinner' class="winner-select text-center pt-0 pb-4">
                <span v-if='review.is_winner == 1'>Това е победителят в конкурса!</span>
                <span v-if='review.is_winner == 0'>Вече сте избрали победител за този конкурс</span>
            </div>

            <div v-if='!hasWinner' class="winner-select text-center pt-0 pb-4">
                <div class="or-sep">
                    <span>класирай на място:</span>
                </div>

                <div v-if='!review.place' class="row">
                    <div class="col-4">
                        <button @click='position(1)' class="btn btn-outline-primary btn-block" :disabled='taken.includes(1)'>
                             1 
                        </button>
                    </div>
                    <div class="col-4">
                        <button @click='position(2)' class="btn btn-outline-primary btn-block" :disabled='taken.includes(2)'>
                             2 
                        </button>
                    </div>
                    <div class="col-4">
                        <button @click='position(3)' class="btn btn-outline-primary btn-block" :disabled='taken.includes(3)'>
                             3 
                        </button>
                    </div>
                </div>

                <div v-if='review.place'>
                    Вие сте класирали това предложение на {{ review.place }} място.
                </div>

            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
           
        },

        props : ['c'],

        data() {

            return {

                isReady : false,
                review  : false,

                isLoading : false,

                hasReview : false,
                hasWinner : false,
                taken : [],

                rmdl : {
                    c1 : 3,
                    c2 : 3,
                    c3 : 3,
                    c4 : 3,
                    c5 : 3,
                    c6 : 3,
                    c7 : 3,
                    score : 3,
                    project_competition_id : this.c,
                    // is_winner : 0,
                    place : null,
                },

                criterias : {
                    c1 : "Технически изисквания – спазване на заданието и изисквания за съдържание на проекта.",
                    c2 : "Качество на визуалното представяне на проекта",
                    c3 : "Постигнат е хармоничен, естетичен и цялостен образ на интериора",
                    c4 : "Функционална организация и оптимизация на пространството",
                    c5 : "Ергономичност – постигнати критерии за комфорт, безопасност и удобство при експлоатация",
                    c6 : "Предложени са иновативни решения при оформление на пространствата",
                    c7 : "Реализацията на проекта е възможна и технически изпълнима",
                }
            }

        },

        methods : {

            getData() {

                var me = this;

                me.ajax.call('cmp:gcr', { c : this.c }, (r) => {

                    if( r.status == 'success' ) {

                        me.taken = r.data.t;

                        if( r.data.r && r.data.r != null ) {
                        
                            me.review = r.data.r;
                            me.hasReview = true;
                        
                        } else {

                            me.review = Object.assign( {}, me.rmdl );

                        }

                        me.isReady = true;

                    }

                })
            },

            leaveReview() {

                if( !confirm('Сигурни ли сте, че искате да поставите тази оценка?') ) {
                    return;
                }

                return this.save();

            },

            save() {
                var me = this;
                
                me.isLoading = true;

                me.ajax.call('cmp:lrv', this.review, (r) => {

                    if( r.status == 'success' ) {

                        me.hasWinner = me.review.is_winner == 1 ? true : false;
                        me.hasReview = true;
                        me.isLoading = false;
                        
                        $.notify('Ревюто беше поставено успешно','success');
                        
                    }

                })
            },

            position( p ) {

                this.review.place = p;

                this.save();

            },

            selectWinner() {

                if( !confirm('Сигурни ли сте, че искате да изберете този идеен проект за победител?') ) {
                    return;
                }

                this.review.is_winner = 1;

                return this.save();

                // var me = this;

                // me.ajax.call('cmp:swn', { c : this.c }, (r) => {

                //     if( r.status == 'success' ) {


                //         me.hasWinner = true;
                        
                //         $.notify('Успешно избрахте победител','success');
                        
                //     }

                // })
            },

            setScore() {

                var score = 0;

                for( var i in this.criterias ) {

                    score += parseFloat( this.review[i] );

                }

                this.review.score = ( score / Object.keys( this.criterias ).length ).toFixed(2);

            }

        }

    }
</script>
